// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-blog-post-js": () => import("/home/runner/work/johaq.com-www/johaq.com-www/src/templates/blog-post.js" /* webpackChunkName: "component---src-templates-blog-post-js" */),
  "component---src-pages-404-js": () => import("/home/runner/work/johaq.com-www/johaq.com-www/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-components-js": () => import("/home/runner/work/johaq.com-www/johaq.com-www/src/pages/components.js" /* webpackChunkName: "component---src-pages-components-js" */),
  "component---src-pages-index-js": () => import("/home/runner/work/johaq.com-www/johaq.com-www/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

